import React, { useEffect, useState, useContext } from "react";
import { loadSpace } from "@usersnap/browser";
import {getInfo as getDatadogInfo} from "@labxchange/util-datadog";

export const UsersnapContext = React.createContext({
    isActive: false,
    usersnapApi: null
});

export const UsersnapProvider = ({ initParams, onLoadCallback, children }) => {
    const [usersnapApi, setUsersnapApi] = useState(null);
    const [isActive, setIsActive] = useState(false);
    const USERSNAP_SPACE_API_KEY = process.env.REACT_APP_USERSNAP_SPACE_API_KEY;

    useEffect(() => {
        if(USERSNAP_SPACE_API_KEY){
            loadSpace(USERSNAP_SPACE_API_KEY).then((api) => {

                // Initialize Usersnap with any required starting parameters.
                api.init({init: initParams, custom: getDatadogInfo()});
                setUsersnapApi(api);
    
                // When Usersnap widget is open set isActive state to true
                // to disable any focus locks applied to dialogs within the content.
                api.on("open", () => setIsActive(true));
                api.on("close", () => setIsActive(false));
    
                // Run the callback event for each content type.
                api.on("load", (event) => {
                    // The onLoadCallback includes the business logic as to which widget should be shown.
                    onLoadCallback(event, api);
                });
            })
        }
    }, [initParams, onLoadCallback])


    return (
        <UsersnapContext.Provider value={{usersnapApi, isActive}}>
            {children}
        </UsersnapContext.Provider>
    )
}

export function useUsersnapApi() {
    return useContext(UsersnapContext).usersnapApi;
}

export function isUsersnapActive() {
    return useContext(UsersnapContext).isActive;
}